// Frontend feature-flag helper. Reads from a window-level config injected by
// the bundle (set in index.html or env) plus localStorage overrides for
// development. Falls back to "off" so anything new defaults safe.

const LS_KEY = 'cs.featureFlags';

function readLocalOverrides() {
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (!raw) return {};
    return JSON.parse(raw);
  } catch (_) {
    return {};
  }
}

function readEnv() {
  const env = (typeof process !== 'undefined' && process.env) ? process.env : {};
  const flags = {};
  for (const key of Object.keys(env)) {
    if (key.startsWith('REACT_APP_FF_')) {
      const name = key.replace('REACT_APP_FF_', '').toLowerCase();
      flags[name] = env[key] === '1' || env[key] === 'true';
    }
  }
  return flags;
}

// Default state per flag. Used when neither localStorage nor env has set it.
// Flags that are safe + visible to opt out of can default ON.
const DEFAULT_FLAGS = {
  fm_two_tier_dashboard: true,   // Clients-first FM dashboard (P1-11/P1-12)
  quote_qualification_gate: false,
};

export function isFlagEnabled(flagKey) {
  const local = readLocalOverrides();
  if (Object.prototype.hasOwnProperty.call(local, flagKey)) return !!local[flagKey];
  const env = readEnv();
  if (Object.prototype.hasOwnProperty.call(env, flagKey)) return !!env[flagKey];
  return !!DEFAULT_FLAGS[flagKey];
}

export function setLocalFlag(flagKey, enabled) {
  const current = readLocalOverrides();
  current[flagKey] = !!enabled;
  try { localStorage.setItem(LS_KEY, JSON.stringify(current)); } catch (_) {}
}

export const FLAGS = {
  FM_TWO_TIER_DASHBOARD: 'fm_two_tier_dashboard',
  QUOTE_QUALIFICATION_GATE: 'quote_qualification_gate',
};
